

// import React, { useState, useMemo, useEffect } from "react";

// import Box from "@mui/material/Box";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from 'dayjs'
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import {
//     TextField,
//     Typography,
//     Grid,
//     TableContainer,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody,
//     Paper,
//     MenuItem,
//     Button,
//     IconButton,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     List,
//     ListItem,
//     ListItemText,
//     ListItemButton,
//     DialogActions,
//     DialogContentText
// } from "@mui/material";
// import { Header } from "../Header";
// import SearchIcon from "@mui/icons-material/Search";
// import { CircularProgress } from '@mui/material';
// import CloseIcon from "@mui/icons-material/Close";
// import InputAdornment from '@mui/material/InputAdornment';
// import { local_url } from "../Const";
// // Dummy data for linked users




// export const CreditNote = () => {
//     const [cnBatchNumber, setCnBatchNumber] = useState("");
//     const [cnBatchDate, setCnBatchDate] = useState(null);
//     const [cnType, setCnType] = useState("");
//     const [cnTypes, setCnTypes] = useState([]);
//     const [searchTerm, setSearchTerm] = useState("");
//     const userId = localStorage.getItem('userId')
//     // Add to your state declarations
//     const [mobileSearchTerm, setMobileSearchTerm] = useState('');

//     console.log('-----', userId);

//     const [isSearching, setIsSearching] = useState(false);
//     const [issueType, setIssueType] = useState("");
//     const [remarks, setRemarks] = useState("");
//     const [tableData, setTableData] = useState([]);
//     const [modalOpen, setModalOpen] = useState(false);
//     const [linkedUsers, setLinkedUsers] = useState([]);
//     const [custIDSearchTerm, setCustIDSearchTerm] = useState("");
//     const [customerNameSearchTerm, setCustomerNameSearchTerm] = useState("");
//     const [searchError, setSearchError] = useState("");
//     const [isFirstRowAdded, setIsFirstRowAdded] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [openDialog, setOpenDialog] = useState(false);

//     const [customerTypes, setCustomerTypes] = useState([]);
//     const [headerInputs, setHeaderInputs] = useState({
//         CustomerMobile: "",
//         CustomerName: "",
//         Pincode: "",
//         CustomerCode: "",
//         Amount: "",
//     });



//     const handleAddClick = () => {
//         const amount = parseFloat(headerInputs.Amount);
//         if (amount > 500) {
//             setOpenDialog(true);
//         } else {
//             addTableRow();
//         }
//     };


//     const handleDialogClose = (confirmed) => {
//         setOpenDialog(false);
//         if (confirmed) {
//             // Set amount to 100000 and add row
//             handleHeaderInputChange("Amount", "100000");
//             setTimeout(() => addTableRow(), 0); // Ensure state is updated before adding row
//         } else {
//             // Clear amount
//             handleHeaderInputChange("Amount", "");
//         }
//     };




//     // Calculate total amount and row count
//     const { totalAmount, rowCount } = useMemo(() => {
//         const total = tableData.reduce((sum, row) => {
//             const amount = parseFloat(row.Amount) || 0;
//             return sum + amount;
//         }, 0);

//         return {
//             totalAmount: total.toFixed(2),
//             rowCount: tableData.length
//         };
//     }, [tableData]);

//     const isAddButtonDisabled = !(
//         headerInputs.CustomerMobile &&
//         headerInputs.CustomerName &&
//         headerInputs.CustomerCode &&
//         headerInputs.Amount &&
//         parseFloat(headerInputs.Amount) > 0 // Ensure Amount is more than 0
//     );



//     const handleAmountChange = (e) => {
//         const value = e.target.value;
//         // Regex: Allows only numbers and a single optional dot for decimals
//         if (/^\d*\.?\d*$/.test(value) || value === "") {
//             handleHeaderInputChange("Amount", value);
//         }
//     };



//     const performSearchByMobile = (mobile) => {


//         const token = localStorage.getItem("AuthorizationToken"); // Retrieve token from localStorage

//         if (!token) {
//             alert("Authorization token is missing. Please log in again.");
//             localStorage.clear();
//             sessionStorage.clear();

//             window.location.href = "/login";
//             return;
//         }

//         setIsSearching(true);
//         setSearchError("");
//         setLinkedUsers([]);

//         fetch(
//             `${local_url}/api/POSCustomerSerch/Get/${issueType}/MOBILE/${mobile}`,
//             {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`, // Include Authorization header
//                     "Content-Type": "application/json", // Include Content-Type header
//                 },
//             }
//         )
//             .then((response) => {
//                 if (!response.ok) {
//                     if (response.status === 401) {
//                         // Handle unauthorized error
//                         alert("Session expired. Please log in again.");
//                         localStorage.clear();
//                         sessionStorage.clear();

//                         window.location.href = "/login";
//                     } else {
//                         throw new Error("Failed to fetch data.");
//                     }
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 if (data.customers && data.customers.length > 0) {
//                     const mergedData = data.customers.map((customer) => {
//                         const address =
//                             data.custAddresses.find(
//                                 (addr) => addr.custID === customer.custID
//                             ) || {};
//                         return { ...customer, ...address };
//                     });
//                     setLinkedUsers(mergedData);
//                 } else {
//                     setSearchError("No customers found for this mobile number.");
//                 }
//             })
//             .catch((error) => {
//                 console.error("Error:", error);
//                 setSearchError("Failed to fetch data. Please try again.");
//             })
//             .finally(() => {
//                 setIsSearching(false);
//             });
//     };





//     const performSearchByCustID = (custID) => {
//         if (!custID) {
//             setSearchError("Please enter a Customer ID.");
//             return;
//         }

//         setIsSearching(true);
//         setSearchError("");
//         setLinkedUsers([]);

//         const token = localStorage.getItem('AuthorizationToken'); // Retrieve the token from localStorage

//         if (!token) {
//             setSearchError("Authorization token is missing. Please log in again.");
//             setIsSearching(false);
//             return;
//         }

//         fetch(
//             `${local_url}/api/POSCustomerSerch/Get/${issueType}/CUSTCODE/${custID}`,
//             {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`, // Add the Authorization header
//                     "Content-Type": "application/json",
//                 },
//             }
//         )
//             .then((response) => {
//                 if (!response.ok) {
//                     if (response.status === 401) {
//                         throw new Error("Unauthorized access. Please log in again.");
//                     }
//                     throw new Error("Failed to fetch data.");
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 if (data.customers && data.customers.length > 0) {
//                     const mergedData = data.customers.map((customer) => {
//                         const address =
//                             data.custAddresses.find((addr) => addr.custID === customer.custID) || {};
//                         return { ...customer, ...address };
//                     });
//                     setLinkedUsers(mergedData);
//                 } else {
//                     setSearchError("No customers found for this Customer ID.");
//                 }
//             })
//             .catch((error) => {
//                 console.error("Error:", error);

//                 // Differentiate errors for user-friendly messages
//                 if (error.message === "Unauthorized access. Please log in again.") {
//                     setSearchError("Session expired. Please log in again.");
//                     localStorage.clear(); // Clear token and other stored data
//                     sessionStorage.clear();

//                     window.location.href = "/login"; // Redirect to the login page
//                 } else {
//                     setSearchError("Failed to fetch data. Please try again.");
//                 }
//             })
//             .finally(() => {
//                 setIsSearching(false);
//             });
//     };



//     const performSearchByCustomerName = (customerName) => {
//         if (!customerName) {
//             setSearchError("Please enter a Customer Name.");
//             return;
//         }

//         const token = localStorage.getItem("AuthorizationToken");
//         if (!token) {
//             alert("Authorization token is missing. Please log in again.");
//             localStorage.clear();
//             sessionStorage.clear();

//             window.location.href = "/login";
//             return;
//         }

//         setIsSearching(true);
//         setSearchError("");
//         setLinkedUsers([]);

//         fetch(
//             `${local_url}/api/POSCustomerSerch/Get/${issueType}/CUSTNAME/${encodeURIComponent(customerName)}`,
//             {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`, // Add Authorization header
//                     "Content-Type": "application/json",
//                 },
//             }
//         )
//             .then((response) => {
//                 if (!response.ok) {
//                     if (response.status === 401) {
//                         // Handle unauthorized error
//                         alert("Session expired. Please log in again.");
//                         localStorage.clear();
//                         sessionStorage.clear();

//                         window.location.href = "/login";
//                     } else {
//                         throw new Error("Failed to fetch data.");
//                     }
//                 }
//                 return response.json();
//             })
//             .then((data) => {
//                 if (data.customers && data.customers.length > 0) {
//                     const mergedData = data.customers.map((customer) => {
//                         const address =
//                             data.custAddresses.find((addr) => addr.custID === customer.custID) || {};
//                         return { ...customer, ...address };
//                     });
//                     setLinkedUsers(mergedData);
//                 } else {
//                     setSearchError("No customers found with this name.");
//                 }
//             })
//             .catch((error) => {
//                 console.error("Error:", error);
//                 setSearchError("Failed to fetch data. Please try again.");
//             })
//             .finally(() => {
//                 setIsSearching(false);
//             });
//     };





//     const handleSearchClick = () => {
//         // Retrieve token from localStorage
//         const token = localStorage.getItem('AuthorizationToken');
//         if (!token) {
//             setSearchError("Authorization token is missing. Please log in again.");
//             setModalOpen(true);
//             return;
//         }

//         // Check if the selected customer type is RT
//         if (issueType === 'RT') {
//             const mobileNumber = headerInputs.CustomerMobile;

//             if (mobileNumber.length <= 10) {
//                 // Existing mobile number search logic
//                 fetch(`${local_url}/api/POSCustomerSerch/Get/${issueType}/MOBILE/${mobileNumber}`, {
//                     headers: {
//                         'Authorization': `Bearer ${token}`
//                     }
//                 })
//                     .then(response => response.json())
//                     .then(data => {
//                         if (data.customers && data.customers.length > 0) {
//                             const mergedData = data.customers.map(customer => {
//                                 const address = data.custAddresses.find(addr => addr.custID === customer.custID) || {};
//                                 return { ...customer, ...address };
//                             });
//                             setLinkedUsers(mergedData);
//                             setSearchError("");
//                         } else {
//                             setLinkedUsers([]);
//                             setSearchError("No linked users found for this mobile number.");
//                         }
//                     })
//                     .catch(error => {
//                         console.error('Error:', error);
//                         setSearchError("Failed to fetch data. Please try again.");
//                     })
//                     .finally(() => {
//                         setModalOpen(true);
//                     });
//             } else {
//                 setSearchError("Please enter a valid 10-digit mobile number.");
//                 setModalOpen(true);
//             }
//         } else {
//             // For non-RT customer types, search by Customer Code
//             const customerCode = headerInputs.CustomerCode;

//             if (customerCode) {
//                 // Existing customer code search logic
//                 fetch(`${local_url}/api/POSCustomerSerch/Get/${issueType}/CUSTCODE/${customerCode}`, {
//                     headers: {
//                         'Authorization': `Bearer ${token}`
//                     }
//                 })
//                     .then(response => response.json())
//                     .then(data => {
//                         if (data && data.customers && data.customers.length > 0) {
//                             const mergedData = data.customers.map(customer => {
//                                 const address = data.custAddresses.find(addr => addr.custID === customer.custID) || {};
//                                 return { ...customer, ...address };
//                             });
//                             setLinkedUsers(mergedData);
//                             setSearchError("");
//                         } else {
//                             setLinkedUsers([]);
//                             setSearchError("No customers found for this Customer Code.");
//                         }
//                     })
//                     .catch(error => {
//                         console.error('Error:', error);
//                         setSearchError("Failed to fetch data. Please try again.");
//                     })
//                     .finally(() => {
//                         setModalOpen(true);
//                     });
//             } else {
//                 setSearchError("Please enter a valid Customer Code.");
//                 setModalOpen(true);
//             }
//         }
//     };



//     const selectCustomer = (customer) => {
//         // Set input fields (optional, if you want to pre-fill the form based on selection)
//         setHeaderInputs({
//             CustomerMobile: customer.mobile,
//             CustomerName: customer.customerName,
//             Mobile: customer.CustomerMobile,
//             CustomerCode: customer.customerCode, // Assuming you have this field
//             Amount: customer.amount, // Assuming amount is relevant
//         });


//         // Close the modal
//         setModalOpen(false);
//     };




//     useEffect(() => {
//         const fetchCustomerTypes = () => {
//             const token = localStorage.getItem('AuthorizationToken'); // Retrieve the token

//             if (!token) {
//                 console.error("Authorization token is missing. Redirecting to login...");
//                 localStorage.clear();
//                 sessionStorage.clear();
//                 // Clear any stored data
//                 window.location.href = "/login"; // Redirect to login
//                 return;
//             }

//             fetch(`${local_url}/api/CustomerList/GetCustomerTypes/C`, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`, // Add the Bearer token
//                     "Content-Type": "application/json",
//                 },
//             })
//                 .then((response) => {
//                     if (response.status === 401) {
//                         throw new Error("Unauthorized access. Session expired.");
//                     }
//                     if (!response.ok) {
//                         throw new Error(`Failed to fetch customer types. Status: ${response.status}`);
//                     }
//                     return response.json();
//                 })
//                 .then((data) => {
//                     setCustomerTypes(data.filter((item) => !item.deleted)); // Filter active items
//                 })
//                 .catch((error) => {
//                     console.error("Error fetching customer types:", error);
//                     if (error.message === "Unauthorized access. Session expired.") {
//                         localStorage.clear();
//                         sessionStorage.clear();
//                         // Clear the session
//                         alert("Session expired. Please log in again.");
//                         window.location.href = "/login"; // Redirect to login
//                     }
//                 });
//         };

//         const fetchCNTypes = () => {
//             const token = localStorage.getItem('AuthorizationToken'); // Retrieve the token

//             if (!token) {
//                 console.error("Authorization token is missing. Redirecting to login...");
//                 localStorage.clear();
//                 sessionStorage.clear();
//                 // Clear any stored data
//                 window.location.href = "/login"; // Redirect to login
//                 return;
//             }

//             fetch(`${local_url}/api/CN/GetCNTypes`, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`, // Add the Bearer token
//                     "Content-Type": "application/json",
//                 },
//             })
//                 .then((response) => {
//                     if (response.status === 401) {
//                         throw new Error("Unauthorized access. Session expired.");
//                     }
//                     if (!response.ok) {
//                         throw new Error(`Failed to fetch CN types. Status: ${response.status}`);
//                     }
//                     return response.json();
//                 })
//                 .then((data) => {
//                     setCnTypes(data.filter((item) => !item.deleted)); // Filter active items
//                 })
//                 .catch((error) => {
//                     console.error("Error fetching CN types:", error);
//                     if (error.message === "Unauthorized access. Session expired.") {
//                         localStorage.clear();
//                         sessionStorage.clear();
//                         // Clear the session
//                         alert("Session expired. Please log in again.");
//                         window.location.href = "/login"; // Redirect to login
//                     }
//                 });
//         };

//         fetchCustomerTypes();
//         fetchCNTypes();
//     }, []);
//     // Ensure useEffect has an empty dependency array

//     const handleHeaderInputChange = (field, value) => {
//         if (field === 'Amount') {
//             // Allow only positive decimal numbers and prevent '-', 'e', or other invalid characters
//             const re = /^(?:[0-9]+(?:\.[0-9]*)?)?$/;
//             if (value === '' || (re.test(value) && parseFloat(value) >= 0)) {
//                 setHeaderInputs(prev => ({
//                     ...prev,
//                     [field]: value
//                 }));
//             }
//         } else {
//             setHeaderInputs(prev => ({
//                 ...prev,
//                 [field]: value
//             }));
//         }
//     };









//     const addTableRow = () => {
//         if (headerInputs.CustomerName && headerInputs.CustomerMobile) {
//             // Check if the CustomerCode already exists in the table
//             const isDuplicate = tableData.some(row => row.CustomerCode === headerInputs.CustomerCode);

//             if (isDuplicate) {
//                 alert('This Customer Code has already been added. Each customer can only be added once.');
//                 return;
//             }

//             const newTableData = [
//                 ...tableData,
//                 { ...headerInputs }
//             ];

//             setTableData(newTableData);

//             // Set flag that first row has been added
//             if (!isFirstRowAdded) {
//                 setIsFirstRowAdded(true);
//             }

//             // Reset header inputs after adding a row
//             setHeaderInputs({
//                 CustomerMobile: "",
//                 CustomerCode: "",
//                 CustomerName: "",
//                 Pincode: "",
//                 Amount: "",
//             });
//         }
//     };


//     const handleSave = async () => {
//         // Validation checks
//         if (!cnType) {
//             alert('Please select CN Type');
//             return;
//         }

//         if (!issueType) {
//             alert('Please select Issue Type');
//             return;
//         }

//         if (!cnBatchDate) {
//             alert('Please select From Date');
//             return;
//         }

//         if (!remarks.trim()) {
//             alert('Please enter Remarks');
//             return;
//         }

//         if (tableData.length === 0) {
//             alert('Please add at least one row to the table');
//             return;
//         }

//         // Retrieve token from localStorage
//         const token = localStorage.getItem('AuthorizationToken');
//         if (!token) {
//             alert('Authorization token is missing. Please log in again.');
//             return;
//         }


//         let cnRuleTypeid = "F"; // Default value
//         if (cnType === "WIOFF") {
//             cnRuleTypeid = "W";
//         } else  {
//             cnRuleTypeid = "F";
//         }



//         // Prepare payload
//         const currentDate = new Date().toISOString();
//         const payload = {
//             cnBatchId: cnBatchNumber || "",
//             businessDate: dayjs(cnBatchDate).format('YYYY-MM-DDTHH:mm:ssZ'),
//             cnRuleType: cnRuleTypeid,
//             remarks: remarks,
//             creditNoteTypeId: cnType,
//             customerTypeId: issueType,
//             approved: true,
//             approvedByUserId: userId,
//             approvedDate: currentDate,
//             createdUserId: userId,
//             createdDate: currentDate,
//             modifiedUserId: userId,
//             modifiedDate: currentDate,
//             deletedUserId: "",
//             deletedDate: currentDate,
//             cnbatchdet: tableData.map((row, index) => ({
//                 lineNumber: ('00' + (index + 1)).slice(-3),
//                 cnBatchId: cnBatchNumber || "",
//                 custId: row.CustomerCode,
//                 cnAmount: parseFloat(row.Amount) || 0,
//                 dml: "I",
//                 deleted: "N"
//             }))
//         };

//         // Set loading state
//         setLoading(true);

//         try {
//             // Make API call
//             const response = await fetch(`${local_url}/api/CN/CreateCNBatch`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${token}` // Add Authorization header
//                 },
//                 body: JSON.stringify(payload)
//             });

//             // Check if response is successful
//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const result = await response.json();
//             console.log('API response:', result);

//             // Check if `description` is in the response
//             if (result && result.description) {
//                 alert(`Credit Note Batch created successfully! : ${result.description}`);
//             } else {
//                 alert('Credit Note Batch created successfully! (No description provided)');
//             }

//             // Optional: Reset form or perform additional actions
//             resetForm();
//         } catch (error) {
//             console.error('Error creating Credit Note Batch:', error);
//             alert('Failed to create Credit Note Batch. Please try again.');
//         } finally {
//             // Reset loading state
//             setLoading(false);
//         }
//     };





//     const resetForm = () => {
//         // Reset all form fields
//         setCnBatchNumber("");
//         setCnBatchDate(null);
//         setCnType("");
//         setIssueType("");
//         setRemarks("");
//         setTableData([]);
//         setIsFirstRowAdded(false);

//         // Reset header inputs
//         setHeaderInputs({
//             CustomerMobile: "",
//             CustomerName: "",
//             Pincode: "",
//             CustomerCode: "",
//             Amount: "",
//         });
//     };


//     return (
//         <>
//             <Header />
//             <Box sx={{ padding: 2, maxWidth: "96vw", margin: "0 auto" }}>
//                 <Typography
//                     variant="h5"
//                     gutterBottom
//                     sx={{
//                         textAlign: "center",
//                         fontWeight: "bold",
//                         color: "#2E7D32",
//                         marginBottom: 2,
//                     }}
//                 >
//                     Credit Note Batch Creation
//                 </Typography>
//                 <Grid container spacing={2}>
//                     <Grid item xs={12} sm={3}>
//                         <TextField
//                             label="CN Batch Number"
//                             variant="outlined"
//                             size="small"
//                             disabled={true}
//                             fullWidth
//                             value={cnBatchNumber}
//                             onChange={(e) => setCnBatchNumber(e.target.value)}
//                             sx={{ backgroundColor: "#F1F8E9" }}
//                         />
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                         <TextField
//                             label="CN Type"
//                             variant="outlined"
//                             size="small"
//                             select
//                             fullWidth
//                             value={cnType}
//                             onChange={(e) => setCnType(e.target.value)}
//                             disabled={isFirstRowAdded}
//                             sx={{ backgroundColor: "#F1F8E9" }}
//                         >
//                             {cnTypes.map((type) => (
//                                 <MenuItem key={type.creditNoteTypeCode} value={type.creditNoteTypeCode}>
//                                     {type.creditNoteTypeName}
//                                 </MenuItem>
//                             ))}
//                         </TextField>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                         <TextField
//                             label="Customer Type"
//                             variant="outlined"
//                             size="small"
//                             select
//                             fullWidth
//                             value={issueType}
//                             onChange={(e) => setIssueType(e.target.value)}
//                             disabled={isFirstRowAdded}
//                             sx={{ backgroundColor: "#F1F8E9" }}
//                         >
//                             {customerTypes.map((type) => (
//                                 <MenuItem key={type.customerTypeCode} value={type.customerTypeCode}>
//                                     {type.customerTypeName}
//                                 </MenuItem>
//                             ))}
//                         </TextField>
//                     </Grid>

//                     <Grid item xs={12} sm={3}>
//                         <LocalizationProvider dateAdapter={AdapterDayjs}>
//                             <DatePicker
//                                 label="From Date"
//                                 value={cnBatchDate}
//                                 onChange={(newDate) => setCnBatchDate(newDate)}
//                                 format="DD/MM/YYYY"
//                                 minDate={dayjs().add(0, 'day')} // T + 1: Tomorrow
//                                 slotProps={{
//                                     textField: {
//                                         fullWidth: true,
//                                         size: "small",
//                                         sx: {
//                                             backgroundColor: "#F1F8E9",
//                                             "& .MuiInputBase-root": { height: "40px" },
//                                         },
//                                     },
//                                 }}
//                             />
//                         </LocalizationProvider>
//                     </Grid>

//                     <Grid item xs={12}>
//                         <TextField
//                             label="Remarks*"
//                             variant="outlined"
//                             size="small"
//                             fullWidth
//                             multiline
//                             rows={2}
//                             value={remarks}
//                             onChange={(e) => setRemarks(e.target.value)}
//                             sx={{ backgroundColor: "#F1F8E9" }}
//                         />
//                     </Grid>
//                 </Grid>

//                 <Box sx={{ padding: 2, maxWidth: "90vw", margin: "0 auto" }}>
//                     <TableContainer component={Paper} sx={{ boxShadow: 3, marginBottom: 2 }}>
//                         <Table sx={{ minWidth: 700, color: "#2E7D32" }}>
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
//                                         {issueType === 'RT' ? (
//                                             <TextField
//                                                 label="Customer Mobile"
//                                                 variant="outlined"
//                                                 size="small"
//                                                 fullWidth
//                                                 value={headerInputs.CustomerMobile}
//                                                 onChange={(e) => {
//                                                     const value = e.target.value;
//                                                     if (/^\d*$/.test(value) && value.length <= 10) {
//                                                         handleHeaderInputChange("CustomerMobile", value);
//                                                     }
//                                                 }}

//                                                 sx={{
//                                                     "& .MuiInputLabel-root": { color: "#60635D" },
//                                                 }}
//                                                 inputProps={{
//                                                     maxLength: 10,
//                                                 }}
//                                                 disabled={!cnType || !issueType}
//                                             />
//                                         ) : (
//                                             <TextField
//                                                 label="Customer ID"
//                                                 variant="outlined"
//                                                 size="small"
//                                                 fullWidth
//                                                 value={headerInputs.CustomerCode}
//                                                 onChange={(e) => handleHeaderInputChange("CustomerCode", e.target.value)}
//                                                 disabled={!cnType || !issueType}
//                                                 sx={{
//                                                     "& .MuiInputLabel-root": { color: "#60635D" },
//                                                 }}
//                                             />
//                                         )}
//                                     </TableCell>

//                                     {/* Search Icon */}
//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1, textAlign: "center" }}>
//                                         <IconButton
//                                             color="primary"
//                                             onClick={handleSearchClick}
//                                             disabled={
//                                                 issueType === 'RT'
//                                                     ? headerInputs.CustomerMobile.length <= 4
//                                                     : !headerInputs.CustomerCode
//                                             }
//                                         >
//                                             <SearchIcon />
//                                         </IconButton>
//                                     </TableCell>

//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
//                                         <TextField
//                                             label="Customer Code"
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             disabled='true'
//                                             value={headerInputs.CustomerCode}
//                                             onChange={(e) => handleHeaderInputChange("CustomerCode", e.target.value)}
//                                             sx={{
//                                                 "& .MuiInputBase-root": { color: "#60635D" },
//                                                 "& .MuiInputLabel-root": { color: "#60635D" },
//                                             }}
//                                         />
//                                     </TableCell>
//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
//                                         <TextField
//                                             label="Customer Name"
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             disabled='true'
//                                             value={headerInputs.CustomerName}
//                                             onChange={(e) => handleHeaderInputChange("CustomerName", e.target.value)}
//                                             sx={{
//                                                 "& .MuiInputBase-root": { color: "#60635D" },
//                                                 "& .MuiInputLabel-root": { color: "#60635D" },
//                                             }}
//                                         />
//                                     </TableCell>
//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
//                                         <TextField
//                                             label="CustomerMobile"
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             disabled='true'

//                                             value={headerInputs.CustomerMobile}
//                                             onChange={(e) => {
//                                                 const value = e.target.value;

//                                                 // Allow only numeric values
//                                                 if (/^\d*$/.test(value) || value === "") {
//                                                     handleHeaderInputChange("CustomerMobile", value);
//                                                 }
//                                             }}
//                                             inputProps={{
//                                                 inputMode: "numeric", // Shows numeric keypad on mobile devices
//                                                 pattern: "[0-9]*", // Enforces numeric-only input
//                                                 maxLength: 10, // Optional: Set a limit for the Pincode length
//                                             }}
//                                             InputLabelProps={{
//                                                 shrink: true,
//                                             }}
//                                             sx={{
//                                                 "& .MuiInputBase-root": { color: "#60635D" },
//                                                 "& .MuiInputLabel-root": { color: "#60635D" },
//                                             }}
//                                         />
//                                     </TableCell>

//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
//                                         <TextField
//                                             label="Amount ₹"
//                                             type="text"
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             value={headerInputs.Amount}
//                                             onChange={handleAmountChange}
//                                             inputProps={{
//                                                 inputMode: "decimal",
//                                                 pattern: "[0-9]*[.]?[0-9]*",
//                                             }}
//                                             InputLabelProps={{
//                                                 shrink: true,
//                                             }}
//                                             sx={{
//                                                 "& .MuiInputBase-root": { color: "#60635D" },
//                                                 "& .MuiInputLabel-root": { color: "#60635D" },
//                                             }}
//                                         />
//                                     </TableCell>


//                                     <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
//                                         <Button
//                                             variant="contained"
//                                             color="secondary"
//                                             size="small"
//                                             fullWidth
//                                             onClick={handleAddClick}
//                                             disabled={isAddButtonDisabled}
//                                         >
//                                             + Add
//                                         </Button>
//                                     </TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {tableData.map((row, index) => (
//                                     <TableRow key={index}>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 fullWidth
//                                                 disabled
//                                                 value={String(index + 1).padStart(3, '0')}
//                                             />
//                                         </TableCell>

//                                         <TableCell colSpan={1}></TableCell>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 fullWidth
//                                                 disabled='true'
//                                                 value={row.CustomerCode || ""}
//                                                 onChange={(e) => {
//                                                     const updatedData = [...tableData];
//                                                     updatedData[index].CustomerCode = e.target.value;
//                                                     setTableData(updatedData);
//                                                 }}
//                                             />
//                                         </TableCell>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 fullWidth
//                                                 disabled='true'
//                                                 value={row.CustomerName || ""}
//                                                 onChange={(e) => {
//                                                     const updatedData = [...tableData];
//                                                     updatedData[index].CustomerName = e.target.value;
//                                                     setTableData(updatedData);
//                                                 }}
//                                             />
//                                         </TableCell>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 fullWidth
//                                                 value={row.CustomerMobile || ""}
//                                                 disabled='true'
//                                                 onChange={(e) => {
//                                                     const updatedData = [...tableData];
//                                                     updatedData[index].CustomerMobile = e.target.value;
//                                                     setTableData(updatedData);
//                                                 }}
//                                             />
//                                         </TableCell>
//                                         <TableCell>
//                                             <TextField
//                                                 size="small"
//                                                 fullWidth
//                                                 disabled='true'
//                                                 value={row.Amount || ""}
//                                                 onChange={(e) => {
//                                                     const updatedData = [...tableData];
//                                                     updatedData[index].Amount = e.target.value;
//                                                     setTableData(updatedData);
//                                                 }}
//                                             />
//                                         </TableCell>
//                                         <TableCell>
//                                             <Button
//                                                 variant="contained"
//                                                 color="error"
//                                                 size="small"
//                                                 onClick={() => {
//                                                     const updatedData = tableData.filter((_, i) => i !== index);
//                                                     setTableData(updatedData);
//                                                 }}
//                                             >
//                                                 Delete
//                                             </Button>
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>

//                     <Dialog open={openDialog} onClose={() => handleDialogClose(false)}>
//         <DialogTitle>Confirm Amount</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//           The entered amount exceeds 500 Rs. You cannot exceed this limit
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => handleDialogClose(false)} color="primary">
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>


//                     {/* Linked Users Modal */}
//                     <Dialog
//                         open={modalOpen}
//                         onClose={() => setModalOpen(false)}
//                         maxWidth="md"
//                         fullWidth
//                     >
//                         <DialogContent>
//                             <Grid container spacing={2}>
//                                 <Grid item xs={12} sm={4}>
//                                     <TextField
//                                         fullWidth
//                                         label="Search by Mobile"
//                                         variant="outlined"
//                                         value={mobileSearchTerm}
//                                         onChange={e => {
//                                             const value = e.target.value;
//                                             if (/^\d*$/.test(value) && value.length <= 10) {
//                                                 setMobileSearchTerm(value);
//                                             }
//                                         }}
//                                         InputProps={{
//                                             endAdornment: (
//                                                 <InputAdornment position="end">
//                                                     <IconButton
//                                                         onClick={() => performSearchByMobile(mobileSearchTerm)}
//                                                         edge="end"
//                                                         disabled={mobileSearchTerm.length === 0 || isSearching}
//                                                     >
//                                                         {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
//                                                     </IconButton>
//                                                 </InputAdornment>
//                                             ),
//                                         }}

//                                         inputProps={{
//                                             maxLength: 10,
//                                         }}
//                                         sx={{ mb: 2 }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} sm={4}>
//                                     <TextField
//                                         fullWidth
//                                         label="Search by CustID"
//                                         variant="outlined"
//                                         value={custIDSearchTerm}
//                                         onChange={e => setCustIDSearchTerm(e.target.value)}
//                                         InputProps={{
//                                             endAdornment: (
//                                                 <InputAdornment position="end">
//                                                     <IconButton
//                                                         onClick={() => performSearchByCustID(custIDSearchTerm)}
//                                                         edge="end"
//                                                         disabled={custIDSearchTerm.length === 0 || isSearching}
//                                                     >
//                                                         {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
//                                                     </IconButton>
//                                                 </InputAdornment>
//                                             ),
//                                         }}
//                                         sx={{ mb: 2 }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} sm={4}>
//                                     <TextField
//                                         fullWidth
//                                         label="Search by Customer Name"
//                                         variant="outlined"
//                                         value={customerNameSearchTerm}
//                                         onChange={e => setCustomerNameSearchTerm(e.target.value)}
//                                         InputProps={{
//                                             endAdornment: (
//                                                 <InputAdornment position="end">
//                                                     <IconButton
//                                                         onClick={() => performSearchByCustomerName(customerNameSearchTerm)}
//                                                         edge="end"
//                                                         disabled={customerNameSearchTerm.length === 0 || isSearching}
//                                                     >
//                                                         {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
//                                                     </IconButton>
//                                                 </InputAdornment>
//                                             ),
//                                         }}
//                                         sx={{ mb: 2 }}
//                                     />
//                                 </Grid>
//                             </Grid>
//                             {searchError && (
//                                 <Typography color="error" sx={{ mb: 2 }}>
//                                     {searchError}
//                                 </Typography>
//                             )}
//                             {isSearching ? (
//                                 <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//                                     <CircularProgress />
//                                 </Box>
//                             ) : (
//                                 <List>
//                                     {linkedUsers.map((user, index) => (
//                                         <ListItem key={index} button onClick={() => selectCustomer(user)} divider>
//                                             <ListItemText
//                                                 primary={`Customer: ${user.customerName} (${user.custID})`}
//                                                 secondary={`Mobile: ${user.mobile}, Branch ID: ${user.branchID}, City ID: ${user.cityId}, Pincode: ${user.pincode}, Address: ${user.customerAddress || 'N/A'}`}
//                                             />
//                                         </ListItem>
//                                     ))}
//                                 </List>
//                             )}
//                         </DialogContent>



//                     </Dialog>

//                     {/* Footer */}
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             padding: 2,
//                             backgroundColor: '#F1F8E9',
//                             marginTop: 2,
//                             borderRadius: 1
//                         }}
//                     >
//                         <Typography variant="subtitle1">
//                             Total Rows: {tableData.length} | Total Amount: ₹
//                             {tableData.reduce((total, row) => total + (parseFloat(row.Amount) || 0), 0)}
//                         </Typography>
//                         <Button
//                             variant="contained"
//                             color="primary"
//                             onClick={handleSave}
//                             disabled={tableData.length === 0 || loading}
//                         >
//                             {loading ? 'Saving...' : 'Save'}
//                         </Button>
//                     </Box>
//                 </Box>
//             </Box>
//         </>
//     );
// }
// export default CreditNote;



















// Chnages on 2901




import React, { useState, useMemo, useEffect } from "react";

import AttachFileIcon from '@mui/icons-material/AttachFile';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Box from "@mui/material/Box";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs'
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
    TextField,
    Typography,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    MenuItem,
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    DialogActions,
    DialogContentText
} from "@mui/material";
import { Header } from "../Header";
import SearchIcon from "@mui/icons-material/Search";
import { CircularProgress } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from '@mui/material/InputAdornment';
import { local_url,local_signage } from "../Const";
// Dummy data for linked users
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const CREDIT_NOTE_FILE_UPLOAD_URL = `${local_signage}/api/v1/uploadfile`;
const CREDIT_NOTE_FILE_FETCH_URL = `${local_signage}/api/v1/fetchfile`;

const uploadFileViaBackend = async (file, batchNumber, customerId, token) => {
    if (!token) {
        throw new Error('Authorization token is missing. Please log in again.');
    }

    const formData = new FormData();
    formData.append('batchNumber', batchNumber);
    formData.append('customerId', customerId);
    formData.append('file', file, file.originalName || file.name);

    const response = await fetch(CREDIT_NOTE_FILE_UPLOAD_URL, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

    const contentType = response.headers.get('content-type') || '';
    const responseBody = contentType.includes('application/json')
        ? await response.json()
        : await response.text();

    if (!response.ok) {
        const message = typeof responseBody === 'string'
            ? responseBody
            : responseBody?.message || responseBody?.error || 'File upload failed';
        throw new Error(message);
    }

    const fileUrl = typeof responseBody === 'object' && responseBody !== null
        ? (
            responseBody.fileUrl ||
            responseBody.url ||
            responseBody.data?.fileUrl ||
            responseBody.data?.url ||
            `${CREDIT_NOTE_FILE_FETCH_URL}?batchNumber=${encodeURIComponent(batchNumber)}&customerId=${encodeURIComponent(customerId)}`
        )
        : `${CREDIT_NOTE_FILE_FETCH_URL}?batchNumber=${encodeURIComponent(batchNumber)}&customerId=${encodeURIComponent(customerId)}`;

    console.log('File uploaded through backend API:', fileUrl);
    return fileUrl;
};
// Modified handleSave function with updated file upload logic





export const CreditNote = () => {
    const [cnBatchNumber, setCnBatchNumber] = useState("");
    const [cnBatchDate, setCnBatchDate] = useState(null);
    const [cnType, setCnType] = useState("");
    const [cnTypes, setCnTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const userId = localStorage.getItem('userId')
    // Add to your state declarations
    const [mobileSearchTerm, setMobileSearchTerm] = useState('');
    const [attachment, setAttachment] = useState(null);
    const [attachmentError, setAttachmentError] = useState("");
    console.log('-----', userId);
    const [uploadProgress, setUploadProgress] = useState({}); // Track upload progress

    const [isSearching, setIsSearching] = useState(false);
    const [issueType, setIssueType] = useState("");
    const [remarks, setRemarks] = useState("");
    const [tableData, setTableData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [linkedUsers, setLinkedUsers] = useState([]);
    const [custIDSearchTerm, setCustIDSearchTerm] = useState("");
    const [customerNameSearchTerm, setCustomerNameSearchTerm] = useState("");
    const [searchError, setSearchError] = useState("");
    const [isFirstRowAdded, setIsFirstRowAdded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [customerTypes, setCustomerTypes] = useState([]);
    const [headerInputs, setHeaderInputs] = useState({
        CustomerMobile: "",
        CustomerName: "",
        Pincode: "",
        CustomerCode: "",
        Amount: "",
        attachments: [] // Initialize attachments as empty array
    });



    const getFileIcon = (fileName) => {
        const extension = fileName?.split('.').pop().toLowerCase() || '';
        const iconStyle = {
            fontSize: 18,
            color: '#81c784'
        };

        switch (extension) {
            case 'pdf':
                return <PictureAsPdfIcon sx={iconStyle} />;
            case 'jpg':
            case 'jpeg':
            case 'png':
                return <ImageIcon sx={iconStyle} />;
            default:
                return <InsertDriveFileIcon sx={iconStyle} />;
        }
    };


    const formatFileSize = (bytes) => {
        if (!bytes) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };





    // Update handleAddClick to use the new validation
    const handleAddClick = () => {
        if (!headerInputs.attachments || headerInputs.attachments.length === 0) {
            setAttachmentError("Please attach at least one file");
            return;
        }

        const amount = parseFloat(headerInputs.Amount);
        if (amount > 1000000) {
            setOpenDialog(true);
        } else {
            addTableRow();
        }
    };

    const handleDialogClose = (confirmed) => {
        setOpenDialog(false);
        if (confirmed) {
            // Set amount to 100000 and add row
            handleHeaderInputChange("Amount", "100000");
            setTimeout(() => addTableRow(), 0); // Ensure state is updated before adding row
        } else {
            // Clear amount
            handleHeaderInputChange("Amount", "");
        }
    };




    // Calculate total amount and row count
    const { totalAmount, rowCount } = useMemo(() => {
        const total = tableData.reduce((sum, row) => {
            const amount = parseFloat(row.Amount) || 0;
            return sum + amount;
        }, 0);

        return {
            totalAmount: total.toFixed(2),
            rowCount: tableData.length
        };
    }, [tableData]);

    const isAddButtonDisabled = useMemo(() => {
        // Check if attachments exist and have length
        const hasAttachments = headerInputs.attachments && headerInputs.attachments.length > 0;

        // Check other required fields
        const hasRequiredFields =
            headerInputs.CustomerMobile &&
            headerInputs.CustomerName &&
            headerInputs.CustomerCode &&
            headerInputs.Amount &&
            parseFloat(headerInputs.Amount) > 0;

        // Button should be enabled (not disabled) if all conditions are met
        return !hasAttachments || !hasRequiredFields;
    }, [headerInputs]);



    const handleAmountChange = (e) => {
        const value = e.target.value;
        // Regex: Allows only numbers and a single optional dot for decimals
        if (/^\d*\.?\d*$/.test(value) || value === "") {
            handleHeaderInputChange("Amount", value);
        }
    };



    const performSearchByMobile = (mobile) => {


        const token = localStorage.getItem("AuthorizationToken"); // Retrieve token from localStorage

        if (!token) {
            alert("Authorization token is missing. Please log in again.");
            localStorage.clear();
            sessionStorage.clear();

            window.location.href = "/login";
            return;
        }

        setIsSearching(true);
        setSearchError("");
        setLinkedUsers([]);

        fetch(
            `${local_url}/api/POSCustomerSerch/Get/${issueType}/MOBILE/${mobile}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Include Authorization header
                    "Content-Type": "application/json", // Include Content-Type header
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        alert("Session expired. Please log in again.");
                        localStorage.clear();
                        sessionStorage.clear();

                        window.location.href = "/login";
                    } else {
                        throw new Error("Failed to fetch data.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                if (data.customers && data.customers.length > 0) {
                    const mergedData = data.customers.map((customer) => {
                        const address =
                            data.custAddresses.find(
                                (addr) => addr.custID === customer.custID
                            ) || {};
                        return { ...customer, ...address };
                    });
                    setLinkedUsers(mergedData);
                } else {
                    setSearchError("No customers found for this mobile number.");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                setSearchError("Failed to fetch data. Please try again.");
            })
            .finally(() => {
                setIsSearching(false);
            });
    };





    const performSearchByCustID = (custID) => {
        if (!custID) {
            setSearchError("Please enter a Customer ID.");
            return;
        }

        setIsSearching(true);
        setSearchError("");
        setLinkedUsers([]);

        const token = localStorage.getItem('AuthorizationToken'); // Retrieve the token from localStorage

        if (!token) {
            setSearchError("Authorization token is missing. Please log in again.");
            setIsSearching(false);
            return;
        }

        fetch(
            `${local_url}/api/POSCustomerSerch/Get/${issueType}/CUSTCODE/${custID}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Add the Authorization header
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        throw new Error("Unauthorized access. Please log in again.");
                    }
                    throw new Error("Failed to fetch data.");
                }
                return response.json();
            })
            .then((data) => {
                if (data.customers && data.customers.length > 0) {
                    const mergedData = data.customers.map((customer) => {
                        const address =
                            data.custAddresses.find((addr) => addr.custID === customer.custID) || {};
                        return { ...customer, ...address };
                    });
                    setLinkedUsers(mergedData);
                } else {
                    setSearchError("No customers found for this Customer ID.");
                }
            })
            .catch((error) => {
                console.error("Error:", error);

                // Differentiate errors for user-friendly messages
                if (error.message === "Unauthorized access. Please log in again.") {
                    setSearchError("Session expired. Please log in again.");
                    localStorage.clear(); // Clear token and other stored data
                    sessionStorage.clear();

                    window.location.href = "/login"; // Redirect to the login page
                } else {
                    setSearchError("Failed to fetch data. Please try again.");
                }
            })
            .finally(() => {
                setIsSearching(false);
            });
    };



    const performSearchByCustomerName = (customerName) => {
        if (!customerName) {
            setSearchError("Please enter a Customer Name.");
            return;
        }

        const token = localStorage.getItem("AuthorizationToken");
        if (!token) {
            alert("Authorization token is missing. Please log in again.");
            localStorage.clear();
            sessionStorage.clear();

            window.location.href = "/login";
            return;
        }

        setIsSearching(true);
        setSearchError("");
        setLinkedUsers([]);

        fetch(
            `${local_url}/api/POSCustomerSerch/Get/${issueType}/CUSTNAME/${encodeURIComponent(customerName)}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Add Authorization header
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        // Handle unauthorized error
                        alert("Session expired. Please log in again.");
                        localStorage.clear();
                        sessionStorage.clear();

                        window.location.href = "/login";
                    } else {
                        throw new Error("Failed to fetch data.");
                    }
                }
                return response.json();
            })
            .then((data) => {
                if (data.customers && data.customers.length > 0) {
                    const mergedData = data.customers.map((customer) => {
                        const address =
                            data.custAddresses.find((addr) => addr.custID === customer.custID) || {};
                        return { ...customer, ...address };
                    });
                    setLinkedUsers(mergedData);
                } else {
                    setSearchError("No customers found with this name.");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                setSearchError("Failed to fetch data. Please try again.");
            })
            .finally(() => {
                setIsSearching(false);
            });
    };





    const handleSearchClick = () => {
        // Retrieve token from localStorage
        const token = localStorage.getItem('AuthorizationToken');
        if (!token) {
            setSearchError("Authorization token is missing. Please log in again.");
            setModalOpen(true);
            return;
        }

        // Check if the selected customer type is RT
        if (issueType === 'RT') {
            const mobileNumber = headerInputs.CustomerMobile;

            if (mobileNumber.length <= 10) {
                // Existing mobile number search logic
                fetch(`${local_url}/api/POSCustomerSerch/Get/${issueType}/MOBILE/${mobileNumber}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.customers && data.customers.length > 0) {
                            const mergedData = data.customers.map(customer => {
                                const address = data.custAddresses.find(addr => addr.custID === customer.custID) || {};
                                return { ...customer, ...address };
                            });
                            setLinkedUsers(mergedData);
                            setSearchError("");
                        } else {
                            setLinkedUsers([]);
                            setSearchError("No linked users found for this mobile number.");
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        setSearchError("Failed to fetch data. Please try again.");
                    })
                    .finally(() => {
                        setModalOpen(true);
                    });
            } else {
                setSearchError("Please enter a valid 10-digit mobile number.");
                setModalOpen(true);
            }
        } else {
            // For non-RT customer types, search by Customer Code
            const customerCode = headerInputs.CustomerCode;

            if (customerCode) {
                // Existing customer code search logic
                fetch(`${local_url}/api/POSCustomerSerch/Get/${issueType}/CUSTCODE/${customerCode}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data && data.customers && data.customers.length > 0) {
                            const mergedData = data.customers.map(customer => {
                                const address = data.custAddresses.find(addr => addr.custID === customer.custID) || {};
                                return { ...customer, ...address };
                            });
                            setLinkedUsers(mergedData);
                            setSearchError("");
                        } else {
                            setLinkedUsers([]);
                            setSearchError("No customers found for this Customer Code.");
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        setSearchError("Failed to fetch data. Please try again.");
                    })
                    .finally(() => {
                        setModalOpen(true);
                    });
            } else {
                setSearchError("Please enter a valid Customer Code.");
                setModalOpen(true);
            }
        }
    };



    const selectCustomer = (customer) => {
        setHeaderInputs(prev => ({
            ...prev,
            CustomerMobile: customer.mobile || "",
            CustomerName: customer.customerName || "",
            CustomerCode: customer.customerCode || customer.custID || "",
        }));
        setModalOpen(false);
    };




    useEffect(() => {
        const fetchCustomerTypes = () => {
            const token = localStorage.getItem('AuthorizationToken'); // Retrieve the token

            if (!token) {
                console.error("Authorization token is missing. Redirecting to login...");
                localStorage.clear();
                sessionStorage.clear();
                // Clear any stored data
                window.location.href = "/login"; // Redirect to login
                return;
            }

            fetch(`${local_url}/api/CustomerList/GetCustomerTypes/C`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Add the Bearer token
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorized access. Session expired.");
                    }
                    if (!response.ok) {
                        throw new Error(`Failed to fetch customer types. Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    setCustomerTypes(data.filter((item) => !item.deleted)); // Filter active items
                })
                .catch((error) => {
                    console.error("Error fetching customer types:", error);
                    if (error.message === "Unauthorized access. Session expired.") {
                        localStorage.clear();
                        sessionStorage.clear();
                        // Clear the session
                        alert("Session expired. Please log in again.");
                        window.location.href = "/login"; // Redirect to login
                    }
                });
        };

        const fetchCNTypes = () => {
            const token = localStorage.getItem('AuthorizationToken'); // Retrieve the token

            if (!token) {
                console.error("Authorization token is missing. Redirecting to login...");
                localStorage.clear();
                sessionStorage.clear();
                // Clear any stored data
                window.location.href = "/login"; // Redirect to login
                return;
            }

            fetch(`${local_url}/api/CN/GetCNTypes`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // Add the Bearer token
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorized access. Session expired.");
                    }
                    if (!response.ok) {
                        throw new Error(`Failed to fetch CN types. Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    setCnTypes(data.filter((item) => !item.deleted)); // Filter active items
                })
                .catch((error) => {
                    console.error("Error fetching CN types:", error);
                    if (error.message === "Unauthorized access. Session expired.") {
                        localStorage.clear();
                        sessionStorage.clear();
                        // Clear the session
                        alert("Session expired. Please log in again.");
                        window.location.href = "/login"; // Redirect to login
                    }
                });
        };

        fetchCustomerTypes();
        fetchCNTypes();
    }, []);
    // Ensure useEffect has an empty dependency array

    const handleHeaderInputChange = (field, value) => {
        if (field === 'Amount') {
            // Allow only positive decimal numbers and prevent '-', 'e', or other invalid characters
            const re = /^(?:[0-9]+(?:\.[0-9]*)?)?$/;
            if (value === '' || (re.test(value) && parseFloat(value) >= 0)) {
                setHeaderInputs(prev => ({
                    ...prev,
                    [field]: value
                }));
            }
        } else {
            setHeaderInputs(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };









    const addTableRow = () => {
        if (!headerInputs.CustomerName ||
            !headerInputs.CustomerMobile ||
            !headerInputs.attachments?.length) {
            setAttachmentError("Please fill all required fields and attach at least one file");
            return;
        }
    
        const isDuplicate = tableData.some(row => row.CustomerCode === headerInputs.CustomerCode);
        if (isDuplicate) {
            alert('This Customer Code has already been added.');
            return;
        }
    
        // Generate a truly unique row identifier with timestamp and random string
        const timestamp = Date.now();
        const randomString = Math.random().toString(36).substring(2, 9);
        const rowUniqueId = `row_${timestamp}_${randomString}`;
    
        // Create copies of the attachment files with row-specific metadata
        const rowAttachments = headerInputs.attachments.map((file, fileIndex) => {
            // Create a new File object with the same content but different metadata
            const newFile = new File(
                [file], // Use the same file content
                `${rowUniqueId}_${fileIndex}_${file.name}`, // Create a row-specific unique filename
                { type: file.type }
            );
            
            // Add metadata to help with tracking and display
            newFile.originalName = file.name;  // Store original name for display
            newFile.rowId = rowUniqueId;       // Link to this specific row
            newFile.fileIndex = fileIndex;     // Position in the row's file list
            
            return newFile;
        });
        
        // Create new row with the copied attachments
        const newRow = {
            ...headerInputs,
            attachments: rowAttachments,
            rowUniqueId: rowUniqueId,
            attachmentNames: rowAttachments.map(file => file.originalName)
        };
    
        setTableData([...tableData, newRow]);
    
        // Reset form
        setHeaderInputs({
            CustomerMobile: "",
            CustomerCode: "",
            CustomerName: "",
            Pincode: "",
            Amount: "",
            attachments: [] // Reset attachments
        });
        setAttachmentError("");
    };
    






    // Add file handling function
// For the file input, modify the handleFileChange function
const handleFileChange = (event) => {
    console.log('File change event triggered');

    const files = Array.from(event.target.files);
    console.log('Files selected:', files);

    // Validate each file
    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ['.pdf', '.jpg', '.jpeg', '.png'];

    const errors = [];
    files.forEach(file => {
        // Check file size
        if (file.size > maxSize) {
            errors.push(`File ${file.name} exceeds 5MB size limit`);
        }

        // Check file type
        const extension = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(extension)) {
            errors.push(`File ${file.name} is not an allowed file type`);
        }
    });

    if (errors.length > 0) {
        setAttachmentError(errors.join('\n'));
        // Reset the file input value to allow same file selection again
        event.target.value = null;
        return;
    }

    setAttachmentError(""); // Clear any previous errors

    // Update headerInputs with new files - safely handle the spread operation
    setHeaderInputs(prev => ({
        ...prev,
        attachments: [...(prev.attachments || []), ...files] // Safely spread prev.attachments
    }));
    
    // Reset the file input value to allow same file selection again
    event.target.value = null;
};

    // Add function to handle file removal
    const handleRemoveFile = (index) => {
        setHeaderInputs(prev => ({
            ...prev,
            attachments: (prev.attachments || []).filter((_, i) => i !== index) // Safely filter attachments
        }));
    };

    // Helper function for validating file types and sizes
    const validateFiles = (files) => {
        const errors = [];
        files.forEach(file => {
            if (!['.pdf', '.jpg', '.jpeg', '.png'].includes(file.name.slice(-4).toLowerCase())) {
                errors.push(`Invalid file type: ${file.name}`);
            }
            if (file.size > 5 * 1024 * 1024) { // 5MB size limit
                errors.push(`File size exceeds the limit: ${file.name}`);
            }
        });
        return errors;
    };


    // Add function to remove individual attachments
    const handleRemoveAttachment = (index) => {
        setHeaderInputs(prev => ({
            ...prev,
            attachments: prev.attachments.filter((_, i) => i !== index)
        }));
    };


    const handleSave = async () => {
        if (!cnType || !issueType || !cnBatchDate || !remarks.trim() || tableData.length === 0) {
            alert('Please fill all required fields');
            return;
        }
    
        const token = localStorage.getItem('AuthorizationToken');
        if (!token) {
            alert('Authorization token is missing. Please log in again.');
            return;
        }
    
        let cnRuleTypeid =
            cnType === "WIOFF" ? "W" :
                cnType === "RBATE" ? "T" :
                    "F"; // Default case if neither condition matches
        setLoading(true);
    
        try {
            // First save the credit note batch
            const currentDate = new Date().toISOString();
            const payload = {
                cnBatchId: "", // Leave empty to let backend generate
                businessDate: dayjs(cnBatchDate).format('YYYY-MM-DDTHH:mm:ssZ'),
                cnRuleType: cnRuleTypeid,
                remarks: remarks,
                creditNoteTypeId: cnType,
                customerTypeId: issueType,
                approved: true,
                approvedByUserId: userId,
                approvedDate: currentDate,
                createdUserId: userId,
                createdDate: currentDate,
                modifiedUserId: userId,
                modifiedDate: currentDate,
                deletedUserId: "",
                deletedDate: currentDate,
                cnbatchdet: tableData.map((row, index) => ({
                    lineNumber: ('00' + (index + 1)).slice(-3),
                    cnBatchId: "", // Leave empty to let backend generate
                    custId: row.CustomerCode,
                    cnAmount: parseFloat(row.Amount) || 0,
                    dml: "I",
                    deleted: "N"
                }))
            };
    
            const response = await fetch(`${local_url}/api/CN/CreateCNBatch`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const result = await response.json();
            console.log('----', result.description);
    
            // Extract the batch number from the API response
            const batchNumber = result.description; // This contains "0000000065" or similar
            console.log('----', batchNumber);
            
        // Inside handleSave function
const uploadPromises = tableData.map(async (row) => {
    const rowFiles = row.attachments || [];
    const customerId = row.CustomerCode;

    return Promise.all(rowFiles.map(async (file, fileIndex) => {
        try {
            // Use a more reliable unique tracking key that includes both the row ID and file index
            const trackingKey = `${row.rowUniqueId}_file${fileIndex}`;
            
            setUploadProgress(prev => ({
                ...prev,
                [trackingKey]: 0
            }));

            // Upload file through backend API instead of browser-side S3 access
            const fileUrl = await uploadFileViaBackend(file, batchNumber, customerId, token);

            setUploadProgress(prev => ({
                ...prev,
                [trackingKey]: 100
            }));

            return fileUrl;
        } catch (error) {
            console.error(`Failed to upload file for customer ${customerId}:`, error);
            
            const trackingKey = `${row.rowUniqueId}_file${fileIndex}`;
            setUploadProgress(prev => ({
                ...prev,
                [trackingKey]: -1
            }));
            
            throw error;
        }
    }));
});
    
            await Promise.all(uploadPromises);
    
            // Success message with the actual batch number
            alert(`Files uploaded successfully! Batch Number: ${batchNumber}`);
            resetForm();
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to upload files. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    

    const renderUploadProgress = (row, fileIndex) => {
        if (!row.attachments || !row.attachments[fileIndex]) return null;
        
        const trackingKey = `${row.rowUniqueId}_file${fileIndex}`;
        const progress = uploadProgress[trackingKey];
        
        if (progress === undefined) return null;
        if (progress === -1) return <ErrorIcon color="error" />;
        if (progress === 100) return <CheckCircleIcon color="success" />;
        return <CircularProgress variant="determinate" value={progress} size={20} />;
    };
    
    // Update the renderAttachmentCell function
    const renderAttachmentCell = (row) => (
        <TableCell>
            {row.attachments && row.attachments.length > 0 ? (
                row.attachments.map((file, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        {getFileIcon(file.originalName || file.name)}
                        <Typography 
                            variant="caption"
                            sx={{
                                flexGrow: 1,
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {file.originalName || file.name.split('_').slice(3).join('_')}
                        </Typography>
                        {renderUploadProgress(row, index)}
                    </Box>
                ))
            ) : row.attachmentNames ? (
                // Handle legacy format if present
                row.attachmentNames.map((name, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        {getFileIcon(name)}
                        <Typography variant="caption">{name}</Typography>
                    </Box>
                ))
            ) : (
                <Typography variant="caption" color="text.secondary">No attachments</Typography>
            )}
        </TableCell>
    );




    const resetForm = () => {
        // Reset all form fields
        setCnBatchNumber("");
        setCnBatchDate(null);
        setCnType("");
        setIssueType("");
        setRemarks("");
        setTableData([]);
        setIsFirstRowAdded(false);

        // Reset header inputs with proper attachment initialization
        setHeaderInputs({
            CustomerMobile: "",
            CustomerName: "",
            Pincode: "",
            CustomerCode: "",
            Amount: "",
            attachments: [] // Explicitly set empty array
        });
    };


    return (
        <>
            <Header />
            <Box sx={{ padding: 2, maxWidth: "96vw", margin: "0 auto" }}>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#2E7D32",
                        marginBottom: 2,
                    }}
                >
                    Credit Note Batch Creation
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="CN Batch Number"
                            variant="outlined"
                            size="small"
                            disabled={true}
                            fullWidth
                            value={cnBatchNumber}
                            onChange={(e) => setCnBatchNumber(e.target.value)}
                            sx={{ backgroundColor: "#F1F8E9" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="CN Type"
                            variant="outlined"
                            size="small"
                            select
                            fullWidth
                            value={cnType}
                            onChange={(e) => setCnType(e.target.value)}
                            disabled={isFirstRowAdded}
                            sx={{ backgroundColor: "#F1F8E9" }}
                        >
                            {cnTypes.map((type) => (
                                <MenuItem key={type.creditNoteTypeCode} value={type.creditNoteTypeCode}>
                                    {type.creditNoteTypeName}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Customer Type"
                            variant="outlined"
                            size="small"
                            select
                            fullWidth
                            value={issueType}
                            onChange={(e) => setIssueType(e.target.value)}
                            disabled={isFirstRowAdded}
                            sx={{ backgroundColor: "#F1F8E9" }}
                        >
                            {customerTypes.map((type) => (
                                <MenuItem key={type.customerTypeCode} value={type.customerTypeCode}>
                                    {type.customerTypeName}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="From Date"
                                value={cnBatchDate}
                                onChange={(newDate) => setCnBatchDate(newDate)}
                                format="DD/MM/YYYY"
                                minDate={dayjs().add(0, 'day')} // T + 1: Tomorrow
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        sx: {
                                            backgroundColor: "#F1F8E9",
                                            "& .MuiInputBase-root": { height: "40px" },
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Remarks*"
                            variant="outlined"
                            size="small"
                            fullWidth
                            multiline
                            rows={2}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            sx={{ backgroundColor: "#F1F8E9" }}
                        />
                    </Grid>
                </Grid>

                <Box sx={{ padding: 2, maxWidth: "90vw", margin: "0 auto" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: 3, marginBottom: 2 }}>
                        <Table sx={{ minWidth: 700, color: "#2E7D32" }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        {issueType === 'RT' ? (
                                            <TextField
                                                label="Customer Mobile"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={headerInputs.CustomerMobile}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value) && value.length <= 10) {
                                                        handleHeaderInputChange("CustomerMobile", value);
                                                    }
                                                }}

                                                sx={{
                                                    "& .MuiInputLabel-root": { color: "#60635D" },
                                                }}
                                                inputProps={{
                                                    maxLength: 10,
                                                }}
                                                disabled={!cnType || !issueType}
                                            />
                                        ) : (
                                            <TextField
                                                label="Customer ID"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={headerInputs.CustomerCode}
                                                onChange={(e) => handleHeaderInputChange("CustomerCode", e.target.value)}
                                                disabled={!cnType || !issueType}
                                                sx={{
                                                    "& .MuiInputLabel-root": { color: "#60635D" },
                                                }}
                                            />
                                        )}
                                    </TableCell>

                                    {/* Search Icon */}
                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1, textAlign: "center" }}>
                                        <IconButton
                                            color="primary"
                                            onClick={handleSearchClick}
                                            disabled={
                                                issueType === 'RT'
                                                    ? headerInputs.CustomerMobile.length <= 4
                                                    : !headerInputs.CustomerCode
                                            }
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </TableCell>

                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        <TextField
                                            label="Customer Code"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled='true'
                                            value={headerInputs.CustomerCode}
                                            onChange={(e) => handleHeaderInputChange("CustomerCode", e.target.value)}
                                            sx={{
                                                "& .MuiInputBase-root": { color: "#60635D" },
                                                "& .MuiInputLabel-root": { color: "#60635D" },
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        <TextField
                                            label="Customer Name"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled='true'
                                            value={headerInputs.CustomerName}
                                            onChange={(e) => handleHeaderInputChange("CustomerName", e.target.value)}
                                            sx={{
                                                "& .MuiInputBase-root": { color: "#60635D" },
                                                "& .MuiInputLabel-root": { color: "#60635D" },
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        <TextField
                                            label="CustomerMobile"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            disabled='true'

                                            value={headerInputs.CustomerMobile}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Allow only numeric values
                                                if (/^\d*$/.test(value) || value === "") {
                                                    handleHeaderInputChange("CustomerMobile", value);
                                                }
                                            }}
                                            inputProps={{
                                                inputMode: "numeric", // Shows numeric keypad on mobile devices
                                                pattern: "[0-9]*", // Enforces numeric-only input
                                                maxLength: 10, // Optional: Set a limit for the Pincode length
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{
                                                "& .MuiInputBase-root": { color: "#60635D" },
                                                "& .MuiInputLabel-root": { color: "#60635D" },
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        <TextField
                                            label="Amount ₹"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={headerInputs.Amount}
                                            onChange={handleAmountChange}
                                            inputProps={{
                                                inputMode: "decimal",
                                                pattern: "[0-9]*[.]?[0-9]*",
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{
                                                "& .MuiInputBase-root": { color: "#60635D" },
                                                "& .MuiInputLabel-root": { color: "#60635D" },
                                            }}
                                        />
                                    </TableCell>


                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            {/* File Upload Button */}
                                            <input
                                                type="file"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                multiple
                                                style={{ display: 'none' }}
                                                id="file-upload"
                                                onChange={handleFileChange}
                                            />
                                            <label htmlFor="file-upload">
                                                <Button
                                                    variant="contained"
                                                    component="span"
                                                    startIcon={<FileUploadIcon />}
                                                    size="small"
                                                    disabled={!cnType || !issueType}
                                                >
                                                    Upload Files
                                                </Button>
                                            </label>

                                            {/* Display attached files */}
                                            {headerInputs.attachments?.map((file, index) => (
                                                <Paper
                                                    key={index}
                                                    elevation={1}
                                                    sx={{
                                                        p: 1,
                                                        backgroundColor: '#f8fff9',
                                                        border: '1px solid #c8e6c9',
                                                        borderRadius: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        maxWidth: '200px'
                                                    }}
                                                >
                                                    {getFileIcon(file.name)}
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                display: 'block',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {file.name}
                                                        </Typography>
                                                        <Typography variant="caption" color="textSecondary">
                                                            {formatFileSize(file.size)}
                                                        </Typography>
                                                    </Box>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleRemoveFile(index)}
                                                        sx={{ padding: 0.5 }}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Paper>
                                            ))}

                                            {/* Error Display */}
                                            {attachmentError && (
                                                <Typography color="error" variant="caption">
                                                    {attachmentError}
                                                </Typography>
                                            )}
                                        </Box>
                                    </TableCell>

                                    <TableCell sx={{ color: "#2E7D32", fontWeight: "bold", padding: 1 }}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            fullWidth
                                            onClick={handleAddClick}
                                            disabled={isAddButtonDisabled} // Remove the attachment check here
                                        >
                                            + Add
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                disabled
                                                value={String(index + 1).padStart(3, '0')}
                                            />
                                        </TableCell>

                                        <TableCell colSpan={1}></TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                disabled='true'
                                                value={row.CustomerCode || ""}
                                                onChange={(e) => {
                                                    const updatedData = [...tableData];
                                                    updatedData[index].CustomerCode = e.target.value;
                                                    setTableData(updatedData);
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                disabled='true'
                                                value={row.CustomerName || ""}
                                                onChange={(e) => {
                                                    const updatedData = [...tableData];
                                                    updatedData[index].CustomerName = e.target.value;
                                                    setTableData(updatedData);
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                value={row.CustomerMobile || ""}
                                                disabled='true'
                                                onChange={(e) => {
                                                    const updatedData = [...tableData];
                                                    updatedData[index].CustomerMobile = e.target.value;
                                                    setTableData(updatedData);
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                disabled='true'
                                                value={row.Amount || ""}
                                                onChange={(e) => {
                                                    const updatedData = [...tableData];
                                                    updatedData[index].Amount = e.target.value;
                                                    setTableData(updatedData);
                                                }}
                                            />
                                        </TableCell>
                                        {renderAttachmentCell(row)}
                                        <TableCell>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                size="small"
                                                onClick={() => {
                                                    const updatedData = tableData.filter((_, i) => i !== index);
                                                    setTableData(updatedData);
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Dialog open={openDialog} onClose={() => handleDialogClose(false)}>
                        <DialogTitle>Confirm Amount</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                The entered amount exceeds 1000000 Rs. You cannot exceed this limit
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleDialogClose(false)} color="primary">
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>


                    {/* Linked Users Modal */}
                    <Dialog
                        open={modalOpen}
                        onClose={() => setModalOpen(false)}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Search by Mobile"
                                        variant="outlined"
                                        value={mobileSearchTerm}
                                        onChange={e => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value) && value.length <= 10) {
                                                setMobileSearchTerm(value);
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => performSearchByMobile(mobileSearchTerm)}
                                                        edge="end"
                                                        disabled={mobileSearchTerm.length === 0 || isSearching}
                                                    >
                                                        {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}

                                        inputProps={{
                                            maxLength: 10,
                                        }}
                                        sx={{ mb: 2 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Search by CustID"
                                        variant="outlined"
                                        value={custIDSearchTerm}
                                        onChange={e => setCustIDSearchTerm(e.target.value)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => performSearchByCustID(custIDSearchTerm)}
                                                        edge="end"
                                                        disabled={custIDSearchTerm.length === 0 || isSearching}
                                                    >
                                                        {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{ mb: 2 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Search by Customer Name"
                                        variant="outlined"
                                        value={customerNameSearchTerm}
                                        onChange={e => setCustomerNameSearchTerm(e.target.value)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => performSearchByCustomerName(customerNameSearchTerm)}
                                                        edge="end"
                                                        disabled={customerNameSearchTerm.length === 0 || isSearching}
                                                    >
                                                        {isSearching ? <CircularProgress size={24} /> : <SearchIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{ mb: 2 }}
                                    />
                                </Grid>
                            </Grid>
                            {searchError && (
                                <Typography color="error" sx={{ mb: 2 }}>
                                    {searchError}
                                </Typography>
                            )}
                            {isSearching ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <List>
                                    {linkedUsers.map((user, index) => (
                                        <ListItem key={index} button onClick={() => selectCustomer(user)} divider>
                                            <ListItemText
                                                primary={`Customer: ${user.customerName} (${user.custID})`}
                                                secondary={`Mobile: ${user.mobile}, Branch ID: ${user.branchID}, City ID: ${user.cityId}, Pincode: ${user.pincode}, Address: ${user.customerAddress || 'N/A'}`}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </DialogContent>



                    </Dialog>

                    {/* Footer */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 2,
                            backgroundColor: '#F1F8E9',
                            marginTop: 2,
                            borderRadius: 1
                        }}
                    >
                        <Typography variant="subtitle1">
                            Total Rows: {tableData.length} | Total Amount: ₹
                            {tableData.reduce((total, row) => total + (parseFloat(row.Amount) || 0), 0)}
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            disabled={tableData.length === 0 || loading}
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
}
export default CreditNote;
